import { OpenInNewTabIcon } from '@fluentui/react-icons';
import * as React from 'react';
import { mergeStyleSets } from '@fluentui/react/lib/Styling';
import { useHistory } from 'react-router-dom';
import classnames from 'classnames';

const styles = mergeStyleSets({
    openInNewTabIcon: {
        position: 'absolute',
        right: 5,
        top: 7,
        cursor: 'pointer',
    },
});

interface OpenLinkIconProps {
    className?: string;
    link: string;
    runBefore?: () => void;
}

export function OpenLinkIcon({ className, link, runBefore = () => {} }: OpenLinkIconProps): JSX.Element {
    const history = useHistory();

    return (
        <OpenInNewTabIcon
            className={classnames(styles.openInNewTabIcon, className)}
            onClick={(event) => {
                event.preventDefault();
                if (runBefore) {
                    runBefore();
                }
                setTimeout(() => {
                    if (event.ctrlKey || event.metaKey) {
                        window.open(link);
                    } else {
                        history.push(link);
                    }
                }, 100);
            }}
        />
    );
}
